import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AesRandomizerService } from './randomizer_service/aes-randomizer.service';
import { LoaderComponent } from './loader/loader.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo:
  //     // localStorage.getItem(AesRandomizerService.pnkyStr) &&
  //     Capacitor.getPlatform() === 'android'

  //       (localStorage.getItem('user_pin_set')?'pinlogin' : 'login-page-app' )
  //       : 'new-home',
  //   pathMatch: 'full',
  // },
  {
  path: '',
  redirectTo:
  //     // localStorage.getItem(AesRandomizerService.pnkyStr) &&
      (Capacitor.getPlatform() === 'android')?'openingpage' : 'master/mod0334'
      // Capacitor.getPlatform() === 'android'
      // ? 'openingpage'
      // : (window.location.hostname === 'neosettlement.awareasso.in'
      //     ? 'master/mod0334'
      //     : 'mod0101')
//  loadChildren: () =>
//       import('./openingpage/openingpage.module').then((m) => m.OpeningpagePageModule)
 ,},
  {
    path: 'home',
    loadChildren: () =>

      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'master',
    loadChildren: () =>
      import('./mastermodule/mastermodule.module').then((m) => m.MastermodulePageModule),
  },
  {
    path: 'mod0101',
    loadChildren: () =>
      import('./mod0101/mod0101.module').then((m) => m.Mod0101PageModule),
  },
  {
    path: 'mod0210',
    loadChildren: () =>
      import('./mod0210/mod0210.module').then((m) => m.Mod0210PageModule),
  },
  {
    path: 'mod0223',
    loadChildren: () =>
      import('./mod0223/mod0223.module').then((m) => m.Mod0223PageModule),
  },
  {
    path: 'mod0224',
    loadChildren: () => import('./mod0224/mod0224.module').then(m => m.Mod0224PageModule)
  },
  {
    path: 'mod0225',
    loadChildren: () => import('./mod0225/mod0225.module').then(m => m.Mod0225PageModule)
  },
  {
    path: 'mod0226',
    loadChildren: () => import('./mod0226/mod0226.module').then(m => m.Mod0226PageModule)
  },
  {
    path: 'mod0227',
    loadChildren: () => import('./mod0227/mod0227.module').then(m => m.Mod0227PageModule)
  },

  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },

  {
    path: 'mod0129',
    loadChildren: () => import('./mod0129/mod0129.module').then(m => m.Mod0129PageModule)
  },

  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {
    path: 'mod0103',
    loadChildren: () => import('./mod0103/mod0103.module').then(m => m.Mod0103PageModule)
  },

  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },
  {
    path: 'mod0229',
    loadChildren: () => import('./mod0229/mod0229.module').then(m => m.Mod0229PageModule)
  },


  {
    path: 'mod0230',
    loadChildren: () => import('./mod0230/mod0230.module').then(m => m.Mod0230PageModule)
  },
  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {

    path: 'mod0130',
    loadChildren: () => import('./mod0130/mod0130.module').then(m => m.Mod0130PageModule)
  },
  {
    path: 'new-home',
    loadChildren: () => import('./new-home/new-home.module').then(m => m.NewHomePageModule)
  },
  {
    path: 'mod0231',
    loadChildren: () => import('./mod0231/mod0231.module').then(m => m.Mod0231PageModule)
  },
  {
    path: 'mod0232',
    loadChildren: () => import('./mod0232/mod0232.module').then(m => m.Mod0232PageModule)
  },
  {
    path: 'mod0233',
    loadChildren: () => import('./mod0233/mod0233.module').then(m => m.Mod0233PageModule)
  },
  {
    path: 'mod0234',
    loadChildren: () => import('./mod0234/mod0234.module').then(m => m.Mod0234PageModule)
  },
  {
    path: 'mod0235',
    loadChildren: () => import('./mod0235/mod0235.module').then(m => m.Mod0235PageModule)
  },
  {
    path: 'mod0236',
    loadChildren: () => import('./mod0236/mod0236.module').then(m => m.Mod0236PageModule)
  },
  {
    path: 'mod0237',
    loadChildren: () => import('./mod0237/mod0237.module').then(m => m.Mod0237PageModule)
  },
  {
    path: 'mod0238',
    loadChildren: () => import('./mod0238/mod0238.module').then(m => m.Mod0238PageModule)
  },
  {
    path: 'mod0239',
    loadChildren: () => import('./mod0239/mod0239.module').then(m => m.Mod0239PageModule)
  },
  {
    path: 'mod0240',
    loadChildren: () => import('./mod0240/mod0240.module').then(m => m.Mod0240PageModule)
  },
  {
    path: 'mod0241',
    loadChildren: () => import('./mod0241/mod0241.module').then(m => m.Mod0241PageModule)
  },
  {
    path: 'mod0242',
    loadChildren: () => import('./mod0242/mod0242.module').then(m => m.Mod0242PageModule)
  },
  {
    path: 'mod0243',
    loadChildren: () => import('./mod0243/mod0243.module').then(m => m.Mod0243PageModule)
  },
  {
    path: 'mod0244',
    loadChildren: () => import('./mod0244/mod0244.module').then(m => m.Mod0244PageModule)
  },
  {
    path: 'mod0245',
    loadChildren: () => import('./mod0245/mod0245.module').then(m => m.Mod0245PageModule)
  },
  {
    path: 'mod0246',
    loadChildren: () => import('./mod0246/mod0246.module').then(m => m.Mod0246PageModule)
  },
  {
    path: 'mod0247',
    loadChildren: () => import('./mod0247/mod0247.module').then(m => m.Mod0247PageModule)
  },
  {
    path: 'mod0248',
    loadChildren: () => import('./mod0248/mod0248.module').then( m => m.Mod0248PageModule)
  },
  {
    path: 'productsview',
    loadChildren: () => import('./productsview/productsview.module').then( m => m.ProductsviewPageModule)
  },
  {
    path: 'mod0249',
    loadChildren: () => import('./mod0249/mod0249.module').then( m => m.Mod0249PageModule)
  },
  {
    path: 'mod0250',
    loadChildren: () => import('./mod0250/mod0250.module').then( m => m.Mod0250PageModule)

  },
  {
    path: 'mod0251',
    loadChildren: () => import('./mod0251/mod0251.module').then( m => m.Mod0251PageModule)

  },


  {
    path: 'mod0252',
    loadChildren: () => import('./mod0252/mod0252.module').then( m => m.Mod0252PageModule)
  },

  {
    path: 'mod0253',
    loadChildren: () => import('./mod0253/mod0253.module').then( m => m.Mod0253PageModule)
  },

  {
    path: 'mod0254',
    loadChildren: () => import('./mod0254/mod0254.module').then( m => m.Mod0254PageModule)
  },
  {
    path: 'mod0255',
    loadChildren: () => import('./mod0255/mod0255.module').then( m => m.Mod0255PageModule)
  },
  {
    path: 'mod0256',
    loadChildren: () => import('./mod0256/mod0256.module').then( m => m.Mod0256PageModule)
  },
  {
    path: 'mod0257',
    loadChildren: () => import('./mod0257/mod0257.module').then( m => m.Mod0257PageModule)
  },
  {
    path: 'item-view',
    loadChildren: () => import('./item-view/item-view.module').then( m => m.ItemViewPageModule)
  },
  {
    path: 'mod0258',
    loadChildren: () => import('./mod0258/mod0258.module').then( m => m.Mod0258PageModule)
  },
  {
    path: 'buyer-aop',
    loadChildren: () => import('./buyer-aop/buyer-aop.module').then( m => m.BuyerAOPPageModule)
  },
  {
    path: 'seller-aop',
    loadChildren: () => import('./seller-aop/seller-aop.module').then( m => m.SellerAOPPageModule)
  },
  {
    path: 'authorized-agent',
    loadChildren: () => import('./authorized-agent/authorized-agent.module').then( m => m.AuthorizedAgentPageModule)
  },
  {
    path: 'mod0264',
    loadChildren: () => import('./mod0264/mod0264.module').then( m => m.Mod0264PageModule)
  },
  {
    path: 'mod0265',
    loadChildren: () => import('./mod0265/mod0265.module').then( m => m.Mod0265PageModule)
  },
  {
    path: 'mod0267',
    loadChildren: () => import('./mod0267/mod0267.module').then( m => m.Mod0267PageModule)
  },

  {
    path: 'mod0266',
    loadChildren: () => import('./mod0266/mod0266.module').then( m => m.Mod0266PageModule)
  },
  {
    path: 'mod0270',
    loadChildren: () => import('./mod0270/mod0270.module').then( m => m.Mod0270PageModule)
  },
  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },

  {
    path: 'mod0129',
    loadChildren: () => import('./mod0129/mod0129.module').then(m => m.Mod0129PageModule)
  },

  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {
    path: 'mod0103',
    loadChildren: () => import('./mod0103/mod0103.module').then(m => m.Mod0103PageModule)
  },

  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },
  {
    path: 'mod0229',
    loadChildren: () => import('./mod0229/mod0229.module').then(m => m.Mod0229PageModule)
  },


  {
    path: 'mod0230',
    loadChildren: () => import('./mod0230/mod0230.module').then(m => m.Mod0230PageModule)
  },
  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {

    path: 'mod0130',
    loadChildren: () => import('./mod0130/mod0130.module').then(m => m.Mod0130PageModule)
  },
  {
    path: 'new-home',
    loadChildren: () => import('./new-home/new-home.module').then(m => m.NewHomePageModule)
  },
  {
    path: 'mod0231',
    loadChildren: () => import('./mod0231/mod0231.module').then(m => m.Mod0231PageModule)
  },
  {
    path: 'mod0232',
    loadChildren: () => import('./mod0232/mod0232.module').then(m => m.Mod0232PageModule)
  },
  {
    path: 'mod0233',
    loadChildren: () => import('./mod0233/mod0233.module').then(m => m.Mod0233PageModule)
  },
  {
    path: 'mod0234',
    loadChildren: () => import('./mod0234/mod0234.module').then(m => m.Mod0234PageModule)
  },
  {
    path: 'mod0235',
    loadChildren: () => import('./mod0235/mod0235.module').then(m => m.Mod0235PageModule)
  },
  {
    path: 'mod0236',
    loadChildren: () => import('./mod0236/mod0236.module').then(m => m.Mod0236PageModule)
  },
  {
    path: 'mod0237',
    loadChildren: () => import('./mod0237/mod0237.module').then(m => m.Mod0237PageModule)
  },
  {
    path: 'mod0238',
    loadChildren: () => import('./mod0238/mod0238.module').then(m => m.Mod0238PageModule)
  },
  {
    path: 'mod0239',
    loadChildren: () => import('./mod0239/mod0239.module').then(m => m.Mod0239PageModule)
  },
  {
    path: 'mod0240',
    loadChildren: () => import('./mod0240/mod0240.module').then(m => m.Mod0240PageModule)
  },
  {
    path: 'mod0241',
    loadChildren: () => import('./mod0241/mod0241.module').then(m => m.Mod0241PageModule)
  },
  {
    path: 'mod0242',
    loadChildren: () => import('./mod0242/mod0242.module').then(m => m.Mod0242PageModule)
  },
  {
    path: 'mod0243',
    loadChildren: () => import('./mod0243/mod0243.module').then(m => m.Mod0243PageModule)
  },
  {
    path: 'mod0244',
    loadChildren: () => import('./mod0244/mod0244.module').then(m => m.Mod0244PageModule)
  },
  {
    path: 'mod0245',
    loadChildren: () => import('./mod0245/mod0245.module').then(m => m.Mod0245PageModule)
  },
  {
    path: 'mod0246',
    loadChildren: () => import('./mod0246/mod0246.module').then(m => m.Mod0246PageModule)
  },
  {
    path: 'mod0247',
    loadChildren: () => import('./mod0247/mod0247.module').then(m => m.Mod0247PageModule)
  },
  {
    path: 'mod0248',
    loadChildren: () => import('./mod0248/mod0248.module').then( m => m.Mod0248PageModule)
  },
  {
    path: 'productsview',
    loadChildren: () => import('./productsview/productsview.module').then( m => m.ProductsviewPageModule)
  },
  {
    path: 'mod0249',
    loadChildren: () => import('./mod0249/mod0249.module').then( m => m.Mod0249PageModule)
  },
  {
    path: 'mod0250',
    loadChildren: () => import('./mod0250/mod0250.module').then( m => m.Mod0250PageModule)

  },
  {
    path: 'mod0251',
    loadChildren: () => import('./mod0251/mod0251.module').then( m => m.Mod0251PageModule)

  },


  {
    path: 'mod0252',
    loadChildren: () => import('./mod0252/mod0252.module').then( m => m.Mod0252PageModule)
  },

  {
    path: 'mod0253',
    loadChildren: () => import('./mod0253/mod0253.module').then( m => m.Mod0253PageModule)
  },

  {
    path: 'mod0254',
    loadChildren: () => import('./mod0254/mod0254.module').then( m => m.Mod0254PageModule)
  },
  {
    path: 'mod0255',
    loadChildren: () => import('./mod0255/mod0255.module').then( m => m.Mod0255PageModule)
  },
  {
    path: 'mod0256',
    loadChildren: () => import('./mod0256/mod0256.module').then( m => m.Mod0256PageModule)
  },
  {
    path: 'mod0257',
    loadChildren: () => import('./mod0257/mod0257.module').then( m => m.Mod0257PageModule)
  },
  {
    path: 'item-view',
    loadChildren: () => import('./item-view/item-view.module').then( m => m.ItemViewPageModule)
  },
  {
    path: 'mod0258',
    loadChildren: () => import('./mod0258/mod0258.module').then( m => m.Mod0258PageModule)
  },
  {
    path: 'buyer-aop',
    loadChildren: () => import('./buyer-aop/buyer-aop.module').then( m => m.BuyerAOPPageModule)
  },
  {
    path: 'seller-aop',
    loadChildren: () => import('./seller-aop/seller-aop.module').then( m => m.SellerAOPPageModule)
  },
  {
    path: 'authorized-agent',
    loadChildren: () => import('./authorized-agent/authorized-agent.module').then( m => m.AuthorizedAgentPageModule)
  },
  {
    path: 'mod0264',
    loadChildren: () => import('./mod0264/mod0264.module').then( m => m.Mod0264PageModule)
  },

  {
    path: 'mod0266',
    loadChildren: () => import('./mod0266/mod0266.module').then( m => m.Mod0266PageModule)
  },
  {
    path: 'mod0272',
    loadChildren: () => import('./mod0272/mod0272.module').then( m => m.Mod0272PageModule)
  },
  {
    path: 'mod0273',
    loadChildren: () => import('./mod0273/mod0273.module').then( m => m.Mod0273PageModule)
  },

  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },

  {
    path: 'mod0129',
    loadChildren: () => import('./mod0129/mod0129.module').then(m => m.Mod0129PageModule)
  },

  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {
    path: 'mod0103',
    loadChildren: () => import('./mod0103/mod0103.module').then(m => m.Mod0103PageModule)
  },

  {
    path: 'mod0165',
    loadChildren: () => import('./mod0165/mod0165.module').then(m => m.Mod0165PageModule)
  },
  {
    path: 'mod0228',
    loadChildren: () => import('./mod0228/mod0228.module').then(m => m.Mod0228PageModule)
  },
  {
    path: 'mod0229',
    loadChildren: () => import('./mod0229/mod0229.module').then(m => m.Mod0229PageModule)
  },


  {
    path: 'mod0230',
    loadChildren: () => import('./mod0230/mod0230.module').then(m => m.Mod0230PageModule)
  },
  {
    path: 'mod0113',
    loadChildren: () => import('./mod0113/mod0113.module').then(m => m.Mod0113PageModule)
  },
  {
    path: 'mod0118',
    loadChildren: () => import('./mod0118/mod0118.module').then(m => m.Mod0118PageModule)
  },
  {

    path: 'mod0130',
    loadChildren: () => import('./mod0130/mod0130.module').then(m => m.Mod0130PageModule)
  },
  {
    path: 'new-home',
    loadChildren: () => import('./new-home/new-home.module').then(m => m.NewHomePageModule)
  },
  {
    path: 'mod0231',
    loadChildren: () => import('./mod0231/mod0231.module').then(m => m.Mod0231PageModule)
  },
  {
    path: 'mod0232',
    loadChildren: () => import('./mod0232/mod0232.module').then(m => m.Mod0232PageModule)
  },
  {
    path: 'mod0233',
    loadChildren: () => import('./mod0233/mod0233.module').then(m => m.Mod0233PageModule)
  },
  {
    path: 'mod0234',
    loadChildren: () => import('./mod0234/mod0234.module').then(m => m.Mod0234PageModule)
  },
  {
    path: 'mod0235',
    loadChildren: () => import('./mod0235/mod0235.module').then(m => m.Mod0235PageModule)
  },
  {
    path: 'mod0236',
    loadChildren: () => import('./mod0236/mod0236.module').then(m => m.Mod0236PageModule)
  },
  {
    path: 'mod0237',
    loadChildren: () => import('./mod0237/mod0237.module').then(m => m.Mod0237PageModule)
  },
  {
    path: 'mod0238',
    loadChildren: () => import('./mod0238/mod0238.module').then(m => m.Mod0238PageModule)
  },
  {
    path: 'mod0239',
    loadChildren: () => import('./mod0239/mod0239.module').then(m => m.Mod0239PageModule)
  },
  {
    path: 'mod0240',
    loadChildren: () => import('./mod0240/mod0240.module').then(m => m.Mod0240PageModule)
  },
  {
    path: 'mod0241',
    loadChildren: () => import('./mod0241/mod0241.module').then(m => m.Mod0241PageModule)
  },
  {
    path: 'mod0242',
    loadChildren: () => import('./mod0242/mod0242.module').then(m => m.Mod0242PageModule)
  },
  {
    path: 'mod0243',
    loadChildren: () => import('./mod0243/mod0243.module').then(m => m.Mod0243PageModule)
  },
  {
    path: 'mod0244',
    loadChildren: () => import('./mod0244/mod0244.module').then(m => m.Mod0244PageModule)
  },
  {
    path: 'mod0245',
    loadChildren: () => import('./mod0245/mod0245.module').then(m => m.Mod0245PageModule)
  },
  {
    path: 'mod0246',
    loadChildren: () => import('./mod0246/mod0246.module').then(m => m.Mod0246PageModule)
  },
  {
    path: 'mod0247',
    loadChildren: () => import('./mod0247/mod0247.module').then(m => m.Mod0247PageModule)
  },
  {
    path: 'mod0248',
    loadChildren: () => import('./mod0248/mod0248.module').then( m => m.Mod0248PageModule)
  },
  {
    path: 'productsview',
    loadChildren: () => import('./productsview/productsview.module').then( m => m.ProductsviewPageModule)
  },
  {
    path: 'mod0249',
    loadChildren: () => import('./mod0249/mod0249.module').then( m => m.Mod0249PageModule)
  },
  {
    path: 'mod0250',
    loadChildren: () => import('./mod0250/mod0250.module').then( m => m.Mod0250PageModule)

  },
  {
    path: 'mod0251',
    loadChildren: () => import('./mod0251/mod0251.module').then( m => m.Mod0251PageModule)

  },

  {
    path: 'mod0252',
    loadChildren: () => import('./mod0252/mod0252.module').then( m => m.Mod0252PageModule)
  },

  {
    path: 'mod0253',
    loadChildren: () => import('./mod0253/mod0253.module').then( m => m.Mod0253PageModule)
  },

  {
    path: 'mod0254',
    loadChildren: () => import('./mod0254/mod0254.module').then( m => m.Mod0254PageModule)
  },
  {
    path: 'mod0255',
    loadChildren: () => import('./mod0255/mod0255.module').then( m => m.Mod0255PageModule)
  },
  {
    path: 'mod0256',
    loadChildren: () => import('./mod0256/mod0256.module').then( m => m.Mod0256PageModule)
  },
  {
    path: 'mod0257',
    loadChildren: () => import('./mod0257/mod0257.module').then( m => m.Mod0257PageModule)
  },
  {
    path: 'item-view',
    loadChildren: () => import('./item-view/item-view.module').then( m => m.ItemViewPageModule)
  },
  {
    path: 'mod0259',
    loadChildren: () => import('./mod0259/mod0259.module').then( m => m.Mod0259PageModule)
  },
  {
    path: 'mod0258',
    loadChildren: () => import('./mod0258/mod0258.module').then( m => m.Mod0258PageModule)
  },
  {
    path: 'buyer-aop',
    loadChildren: () => import('./buyer-aop/buyer-aop.module').then( m => m.BuyerAOPPageModule)
  },
  {
    path: 'seller-aop',
    loadChildren: () => import('./seller-aop/seller-aop.module').then( m => m.SellerAOPPageModule)
  },
  {
    path: 'authorized-agent',
    loadChildren: () => import('./authorized-agent/authorized-agent.module').then( m => m.AuthorizedAgentPageModule)
  },
  {
    path: 'mod0264',
    loadChildren: () => import('./mod0264/mod0264.module').then( m => m.Mod0264PageModule)
  },
  {
    path: 'mod0265',
    loadChildren: () => import('./mod0265/mod0265.module').then( m => m.Mod0265PageModule)
  },
  {
    path: 'mod0267',
    loadChildren: () => import('./mod0267/mod0267.module').then( m => m.Mod0267PageModule)
  },
  {
    path: 'mod0271',
    loadChildren: () => import('./mod0271/mod0271.module').then( m => m.Mod0271PageModule)
  },

  {
    path: 'mod0266',
    loadChildren: () => import('./mod0266/mod0266.module').then( m => m.Mod0266PageModule)
  },
  {
    path: 'mod0260',
    loadChildren: () => import('./mod0260/mod0260.module').then( m => m.Mod0260PageModule)
  },
  {
    path: 'mod0261',
    loadChildren: () => import('./mod0261/mod0261.module').then( m => m.Mod0261PageModule)
  },
  {
    path: 'mod0262',
    loadChildren: () => import('./mod0262/mod0262.module').then( m => m.Mod0262PageModule)
  },
  {
    path: 'mod0263',
    loadChildren: () => import('./mod0263/mod0263.module').then( m => m.Mod0263PageModule)
  },
  {
    path: 'mod0268',
    loadChildren: () => import('./mod0268/mod0268.module').then( m => m.Mod0268PageModule)
  },
  {
    path: 'mod0269',
    loadChildren: () => import('./mod0269/mod0269.module').then( m => m.Mod0269PageModule)
  },
  {
    path: 'mod0268',
    loadChildren: () => import('./mod0268/mod0268.module').then( m => m.Mod0268PageModule)
  },
  {
    path: 'pinlogin',
    loadChildren: () => import('./pinlogin/pinlogin.module').then( m => m.PinloginPageModule)
  },
  {
    path: 'setpin',
    loadChildren: () => import('./setpin/setpin.module').then( m => m.SetpinPageModule)
  },
  {
    path: 'login-page-app',
    loadChildren: () => import('./login-page-app/login-page-app.module').then( m => m.LoginPageAppPageModule)
  },
  {
    path: 'new-user-page',
    loadChildren: () => import('./new-user-page/new-user-page.module').then( m => m.NewUserPagePageModule)
  },
  {
    path: 'session-home-page',
    loadChildren: () => import('./session-home-page/session-home-page.module').then( m => m.SessionHomePagePageModule)
  },
  {
    path: 'forgot-pass-app',
    loadChildren: () => import('./forgot-pass-app/forgot-pass-app.module').then( m => m.ForgotPassAppPageModule)
  },
  {
    path: 'privacy-policy-page',
    loadChildren: () => import('./privacy-policy-page/privacy-policy-page.module').then( m => m.PrivacyPolicyPagePageModule)
  },

{
    path: 'mod0274',
    loadChildren: () => import('./mod0274/mod0274.module').then( m => m.Mod0274PageModule)
  },
  {
    path: 'license',
    loadChildren: () => import('./license/license.module').then( m => m.LicensePageModule)
  },
  {
    path: 'mod0420',
    loadChildren: () => import('./mod0420/mod0420.module').then( m => m.Mod0420PageModule)},
    {
    path: 'openingpage',
    loadChildren: () => import('./openingpage/openingpage.module').then( m => m.OpeningpagePageModule)
  },
  {
    path: 'mod0275',
    loadChildren: () => import('./mod0275/mod0275.module').then( m => m.Mod0275PageModule)
  },
  {
    path: 'mod0276',
    loadChildren: () => import('./mod0276/mod0276.module').then( m => m.Mod0276PageModule)
  },
  {
    path: 'mod0277',
    loadChildren: () => import('./mod0277/mod0277.module').then( m => m.Mod0277PageModule)
  },
  {
    path: 'mod0278',
    loadChildren: () => import('./mod0278/mod0278.module').then( m => m.Mod0278PageModule)},
    {
    path: 'mod0279',
    loadChildren: () => import('./mod0279/mod0279.module').then( m => m.Mod0279PageModule)
  },
  {
    path: 'mod0280',
    loadChildren: () => import('./mod0280/mod0280.module').then( m => m.Mod0280PageModule)
  },
  {
    path: 'mod0281',
    loadChildren: () => import('./mod0281/mod0281.module').then( m => m.Mod0281PageModule)
  },
  {
    path: 'sell',
    loadChildren: () => import('./sell/sell.module').then( m => m.SellPageModule)
  },
  {
    path: 'sell-details',
    loadChildren: () => import('./sell-details/sell-details.module').then( m => m.SellDetailsPageModule)
  },
  {
    path: 'mod0282',
    loadChildren: () => import('./mod0282/mod0282.module').then( m => m.Mod0282PageModule)
  },
  {
    path: 'mod0283',
    loadChildren: () => import('./mod0283/mod0283.module').then( m => m.Mod0283PageModule)
  },
  {
    path: 'mod0284',
    loadChildren: () => import('./mod0284/mod0284.module').then( m => m.Mod0284PageModule)
  },
  {
    path: 'mod0285',
    loadChildren: () => import('./mod0285/mod0285.module').then( m => m.Mod0285PageModule)
  },
  {
    path: 'mod0286',
    loadChildren: () => import('./mod0286/mod0286.module').then( m => m.Mod0286PageModule)
  },
  {
    path: 'mod0287',
    loadChildren: () => import('./mod0287/mod0287.module').then( m => m.Mod0287PageModule)
  },
  {
    path: 'mod0288',
    loadChildren: () => import('./mod0288/mod0288.module').then( m => m.Mod0288PageModule)
  },
  // {
  //   path: 'mstarsettlementpages',
  //   loadChildren: () => import('./mstarsettlementpages/mstarsettlementpages.module').then( m => m.MstarsettlementpagesPageModule)
  // },
  {
    path: 'mod0290',
    loadChildren: () => import('./mod0290/mod0290.module').then( m => m.Mod0290PageModule)
  },
  {
    path: 'mod0291',
    loadChildren: () => import('./mod0291/mod0291.module').then( m => m.Mod0291PageModule)
  },
  // {
  //   path: 'mod0362',
  //   loadChildren: () => import('./mod0362/mod0362.module').then( m => m.Mod0362PageModule)
  // },



  // {
  //   path: 'mod0298',
  //   loadChildren: () => import('./mod0298/mod0298.module').then( m => m.Mod0298PageModule)
  // },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
